import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";

export class LayoutFooter extends BaseComponent<ILayoutFooterProps, ILayoutFooterState>
{
    public render(): JSX.Element
    {
        return (
            <>
                {this.props.children}
            </>
        );
    }
}

export interface ILayoutFooterProps
{
    children: ReactNode;
}

export interface ILayoutFooterState { }
